<template>
  <div class="scanner-container">
    <div class="scan btn-start" @click="handleScanCode">扫一扫获取结果</div>
    <div v-if="scanResult" class="result-box">
      <p><strong>扫描结果：</strong></p>
      <p class="result-text" v-html="scanResult"></p>
    </div>
  </div>
</template>

<script>

import { wxGetSignature } from '@/utils/wxConfig'
import { decryptData } from '@/api/api'
export default {
  name: "QRCodeScanner",
  data() {
    return {
      scanResult: null, // Html5Qrcode 实例
    };
  },
  methods: {
    handleScanCode() {
      const _this = this
      wxGetSignature().then(() => {
        this.$wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
          success: function (res) {
            var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
            _this.aaa = result
            const para = {
              encryptedData: result
            }
            decryptData(para).then(({ error, response }) => {
              if (error.code == 0) {
                _this.scanResult = response.data ? response.data.replace(/\n/g, '<br>') : '';
              }
            })
          }
        });
      })
    }
      
  }
};
</script>

<style scoped>
.scanner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  font-family: Arial, sans-serif;
}

.scan {
  padding: 10px 20px;
  cursor: pointer;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  transition: opacity 0.3s;
}

.btn-start {
  background-color: #28a745;
  color: white;
}

.btn-stop {
  background-color: #dc3545;
  color: white;
}
</style>
